var _rect, _rect2, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiblingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.49414,
    width: 30.4771,
    height: 30.4771,
    fill: "white",
    stroke: "#0E0F10"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8413,
    y: 8.49414,
    width: 30.4771,
    height: 30.4771,
    rx: 15.2385,
    fill: "white",
    stroke: "#0E0F10"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.1128,
    y1: 7.99414,
    x2: 16.1128,
    y2: 0.999234,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5796,
    y1: 7.99414,
    x2: 61.5796,
    y2: 0.999234,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.7383,
    y1: 0.5,
    x2: 62.0795,
    y2: 0.499996,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiblingLine);
export default __webpack_public_path__ + "static/media/sibling-line.8de58905f7a38700afb1d6f36d9395ba.svg";
export { ForwardRef as ReactComponent };